// extracted by mini-css-extract-plugin
export var closeButton = "_oh-2";
export var closeButtonIcon = "_oh-3";
export var lightboxContent = "_oh-1";
export var lightboxOverlay = "_oh-0";